const makeVendorBid = ({
  vendor_name,
  vendor_id,
  r0_unit = 0,
  r0_amount = 0,
  r1_unit = 0,
  r1_amount = 0,
  r_unit = 0,
  r_amount = 0,
  r0_date = "15-02-26",
  r1_date = "18-02-26",
  r_date = "20-02-26",
}) => ({
  vendor_name,
  vendor_id,
  r0_price: [
    {
      r_unit_price: r0_unit,
      r_amount_without_gst: r0_amount,
      r_amount_with_gst: Math.round(r0_amount * 1.05),
      bid_date: r0_date,
      is_initial_final_bid: false,
    },
  ],
  r1_price: [
    {
      r_unit_price: r1_unit,
      r_amount_without_gst: r1_amount,
      r_amount_with_gst: Math.round(r1_amount * 1.05),
      bid_date: r1_date,
    },
  ],
  r_price: [
    {
      r_unit_price: r_unit,
      r_amount_without_gst: r_amount,
      r_amount_with_gst: Math.round(r_amount * 1.05),
      bid_date: r_date,
    },
  ],
});

const makeVendorSubTotal = (vendors) =>
  vendors.flatMap((v) => [
    {
      vendor_name: v.name,
      vendor_id: v.id,
      round: "r",
      bid_date: "20-02-26",
      basic_price: v.basic,
      commission_charges: v.commission,
      taxes: v.taxes,
      total_price: v.total,
      contingency: 2500,
      total_with_tax: v.total + 2500,
      payment_terms: "30 Days",
      payment_security_details: "BG",
      commercial_ranking: v.rank,
      material_type_details: {},
    },
    {
      vendor_name: v.name,
      vendor_id: v.id,
      round: "r1",
      bid_date: "18-02-26",
      basic_price: v.basic + 5000,
      commission_charges: v.commission,
      taxes: v.taxes,
      total_price: v.total + 5000,
      contingency: 2500,
      total_with_tax: v.total + 7500,
      payment_terms: "30 Days",
      payment_security_details: "BG",
      commercial_ranking: v.rank + 1,
      material_type_details: {},
    },
    {
      vendor_name: v.name,
      vendor_id: v.id,
      round: "r0",
      bid_date: "15-02-26",
      basic_price: v.basic + 10000,
      commission_charges: v.commission,
      taxes: v.taxes,
      total_price: v.total + 10000,
      contingency: 2500,
      total_with_tax: v.total + 12500,
      payment_terms: "30 Days",
      payment_security_details: "BG",
      commercial_ranking: v.rank + 2,
      material_type_details: {},
    },
  ]);

const MATERIALS = [
  {
    rfq_material_type_id: 8299,
    rfq_material_type_name: "Crushed Sand",
    rfq_material_type_sub_category: "IS: 2116",
    rfq_material_type_total_quantity: 1,
    rfq_material_type_uom: "MT",
    gst_rate: 5,
    estimated_material_unit_price: 420,
    vendors: [
      makeVendorBid({
        vendor_name: "Vendor One",
        vendor_id: 51,
        r0_unit: 440,
        r0_amount: 440,
        r1_unit: 435,
        r1_amount: 435,
        r_unit: 430,
        r_amount: 430,
      }),
      makeVendorBid({
        vendor_name: "Vendor Two Procem",
        vendor_id: 55,
        r0_unit: 450,
        r0_amount: 450,
        r1_unit: 445,
        r1_amount: 445,
        r_unit: 438,
        r_amount: 438,
      }),
      makeVendorBid({
        vendor_name: "Vendor Three",
        vendor_id: 60,
        r0_unit: 455,
        r0_amount: 455,
        r1_unit: 448,
        r1_amount: 448,
        r_unit: 442,
        r_amount: 442,
      }),
    ],
    last_purchase_price: [
      {
        vendor_name: "Last Vendor",
        unit_price: 425,
        lpp_po_number_date: "10-01-26",
        "30_days_avg_price": 428,
        item_wise_l1: 420,
        "30_days_avg_price_sb": 430,
      },
    ],
    vendor_sub_total: makeVendorSubTotal([
      { id: 51, name: "Vendor One", basic: 125000, commission: 2500, taxes: 6250, total: 133750, rank: 1 },
      { id: 55, name: "Vendor Two Procem", basic: 128000, commission: 2600, taxes: 6400, total: 137000, rank: 2 },
      { id: 60, name: "Vendor Three", basic: 130000, commission: 2700, taxes: 6500, total: 139200, rank: 3 },
    ]),
  },
  {
    rfq_material_type_id: 8300,
    rfq_material_type_name: "River Sand",
    rfq_material_type_sub_category: "IS: 2116",
    rfq_material_type_total_quantity: 2,
    rfq_material_type_uom: "MT",
    gst_rate: 5,
    estimated_material_unit_price: 410,
    vendors: [
      makeVendorBid({
        vendor_name: "Vendor One",
        vendor_id: 51,
        r0_unit: 430,
        r0_amount: 860,
        r1_unit: 425,
        r1_amount: 850,
        r_unit: 420,
        r_amount: 840,
      }),
      makeVendorBid({
        vendor_name: "Vendor Two Procem",
        vendor_id: 55,
        r0_unit: 435,
        r0_amount: 870,
        r1_unit: 428,
        r1_amount: 856,
        r_unit: 422,
        r_amount: 844,
      }),
    ],
    last_purchase_price: [
      {
        vendor_name: "Last Vendor",
        unit_price: 415,
        lpp_po_number_date: "12-01-26",
        "30_days_avg_price": 418,
        item_wise_l1: 410,
        "30_days_avg_price_sb": 420,
      },
    ],
    vendor_sub_total: makeVendorSubTotal([
      { id: 51, name: "Vendor One", basic: 98000, commission: 2000, taxes: 4900, total: 104900, rank: 1 },
      { id: 55, name: "Vendor Two Procem", basic: 101000, commission: 2100, taxes: 5050, total: 108150, rank: 2 },
    ]),
  },
  {
    rfq_material_type_id: 8129,
    rfq_material_type_name: "Crushed Sand",
    rfq_material_type_sub_category: "Zone II",
    rfq_material_type_total_quantity: 2,
    rfq_material_type_uom: "MT",
    gst_rate: 5,
    estimated_material_unit_price: 400,
    vendors: [
      makeVendorBid({
        vendor_name: "Vendor Two Procem",
        vendor_id: 55,
        r0_unit: 410,
        r0_amount: 820,
        r1_unit: 405,
        r1_amount: 810,
        r_unit: 400,
        r_amount: 800,
      }),
      makeVendorBid({
        vendor_name: "Vendor Three",
        vendor_id: 60,
        r0_unit: 415,
        r0_amount: 830,
        r1_unit: 408,
        r1_amount: 816,
        r_unit: 402,
        r_amount: 804,
      }),
    ],
    last_purchase_price: [
      {
        vendor_name: "Last Vendor",
        unit_price: 398,
        lpp_po_number_date: "08-01-26",
        "30_days_avg_price": 402,
        item_wise_l1: 395,
        "30_days_avg_price_sb": 405,
      },
    ],
    vendor_sub_total: makeVendorSubTotal([
      { id: 55, name: "Vendor Two Procem", basic: 88000, commission: 1800, taxes: 4400, total: 94200, rank: 1 },
      { id: 60, name: "Vendor Three", basic: 90000, commission: 1900, taxes: 4500, total: 96400, rank: 2 },
    ]),
  },
  {
    rfq_material_type_id: 8130,
    rfq_material_type_name: "River Sand",
    rfq_material_type_sub_category: "Zone II",
    rfq_material_type_total_quantity: 1,
    rfq_material_type_uom: "MT",
    gst_rate: 5,
    estimated_material_unit_price: 405,
    vendors: [
      makeVendorBid({
        vendor_name: "Vendor One",
        vendor_id: 51,
        r0_unit: 420,
        r0_amount: 420,
        r1_unit: 415,
        r1_amount: 415,
        r_unit: 410,
        r_amount: 410,
      }),
      makeVendorBid({
        vendor_name: "Vendor Three",
        vendor_id: 60,
        r0_unit: 425,
        r0_amount: 425,
        r1_unit: 418,
        r1_amount: 418,
        r_unit: 412,
        r_amount: 412,
      }),
    ],
    last_purchase_price: [
      {
        vendor_name: "Last Vendor",
        unit_price: 408,
        lpp_po_number_date: "05-01-26",
        "30_days_avg_price": 410,
        item_wise_l1: 400,
        "30_days_avg_price_sb": 412,
      },
    ],
    vendor_sub_total: makeVendorSubTotal([
      { id: 51, name: "Vendor One", basic: 72000, commission: 1500, taxes: 3600, total: 77100, rank: 1 },
      { id: 60, name: "Vendor Three", basic: 74000, commission: 1600, taxes: 3700, total: 79300, rank: 2 },
    ]),
  },
];

/** API-shaped response: one placeholder city/site bucket holding all materials */
export const STATIC_COMPARATIVE_RESPONSE = {
  data: {
    data: {
      rfq_number: "GP-00057",
      buyer_name: "General Procurement Buyer",
      category_tree_name: "Sand",
      contingency_charges: 2.5,
      supplier_overhead_profit_perc: 10,
      rfq_vendor_sub_total: makeVendorSubTotal([
        {
          id: 51,
          name: "Vendor One",
          basic: 295000,
          commission: 6000,
          taxes: 14750,
          total: 315750,
          rank: 1,
        },
        {
          id: 55,
          name: "Vendor Two Procem",
          basic: 317000,
          commission: 6400,
          taxes: 15850,
          total: 339250,
          rank: 2,
        },
        {
          id: 60,
          name: "Vendor Three",
          basic: 304000,
          commission: 6200,
          taxes: 15200,
          total: 325400,
          rank: 3,
        },
      ]),
      comparative_details_by_rfq_site_wise: [
        {
          rfq_city_name: "General",
          rfq_site_wise_details: [
            {
              rfq_site_name: "—",
              rfq_material_wise_details: MATERIALS,
            },
          ],
        },
      ],
    },
  },
};

export const buildGeneralComparativeFilterPayload = (state) => ({
  rfq_id: 578,
  material_type_names:
    state.material_type_names?.length > 0 ? state.material_type_names : null,
});

export const buildGeneralComparativeSubmitPayload = ({
  rfqId,
  state,
  selectedVendors = {},
}) => ({
  rfq_id: rfqId ?? 578,
  filters: buildGeneralComparativeFilterPayload(state),
  vendor_selection: selectedVendors,
  comparative_type: "general_procurement_material_wise",
});
